import { NotificationSetting } from '@models/account/notification-setting.model';
import { User } from '@models/user.model';

import { UserSelfPreferencesPatchParams } from './user-self-preferences-patch-params.model';

export class UserSelfPatchParams extends UserSelfPreferencesPatchParams {
  constructor(user: User) {
    super(user);
  }

  getParams(): unknown {
    const apiParams = super.getParams();
    apiParams['firstname'] = this.user.firstname;
    apiParams['lastname'] = this.user.lastname;
    apiParams['contact_email'] = this.user.emailSecondary;
    apiParams['primary_phone'] = this.user.phone;
    apiParams['secondary_phone'] = this.user.phoneSecondary;
    apiParams['position'] = this.user.position;
    apiParams['file'] = this.user.avatarFile;
    apiParams['notifications_settings'] = this.user.notificationsSettings.map((notificationSetting: NotificationSetting) => ({
      event_type: notificationSetting.type,
      activated: notificationSetting.activated,
      priority: notificationSetting.priority,
    }));

    return apiParams;
  }
}
